import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12 px-4" data-id="element-36">
      <div className="max-w-4xl mx-auto text-center" data-id="element-37">
        <h3 className="text-2xl font-bold mb-6 font-serif" data-id="element-38">Mamá Digital</h3>
        <p className="text-gray-400 mb-8 max-w-md mx-auto" data-id="element-39">
          Ayudando a mamás latinas a construir ingresos desde casa, sin
          descuidar lo más importante.
        </p>
        <div className="border-t border-gray-800 pt-8 text-sm text-gray-500" data-id="element-40">
          <p data-id="element-41">
            © {new Date().getFullYear()} Mamá Digital. Todos los derechos
            reservados.
          </p>
          <div className="mt-4 space-x-4" data-id="element-42">
            <a href="#" className="hover:text-white transition-colors" data-id="element-43">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-44">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-45">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}